var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", [
      _vm.isBasketPage
        ? _c("p", { staticClass: "font-weight-normal border-bottom" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$resourceString["basket.Sidebar.Title"]) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isCheckoutPage
        ? _c("p", { staticClass: "font-weight-normal border-bottom" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$resourceString["checkout.Sidebar.Title"]) +
                "\n    "
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.trayItemsCount > 0 || _vm.siteItemsCount > 0
      ? _c("div", [
          _vm.siteItemsCount
            ? _c(
                "p",
                { staticClass: "font-16 font-weight-bold text-uppercase" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$resourceString["basket.Sidebar.Samplequantity"]
                      ) +
                      ":\n      " +
                      _vm._s(_vm.siteItemsCount) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.trayItemsCount
            ? _c(
                "p",
                { staticClass: "font-16 font-weight-bold text-uppercase" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$resourceString["basket.Sidebar.trayquantity"]
                      ) +
                      " :\n      " +
                      _vm._s(_vm.trayItemsCount) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isBasketPage
            ? _c("div", [
                _vm.checkOutType.isSameAddress
                  ? _c("div", { attrs: { id: "WebsiteCheckoutContainer" } }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary checkout-btn",
                          attrs: {
                            disabled:
                              _vm.quantityValidation ||
                              _vm.sampleSizeValidation,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.checkOut("Mixed")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$resourceString["basket.Sidebar.Checkout"]
                              ) +
                              "\n          "
                          ),
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--ko-arrow-next"
                          })
                        ]
                      )
                    ])
                  : !_vm.checkOutType.isSameAddress &&
                    (_vm.trayItemsCount == 0 || _vm.siteItemsCount == 0)
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary checkout-btn",
                          attrs: {
                            disabled:
                              _vm.quantityValidation ||
                              _vm.sampleSizeValidation,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.checkOut(
                                _vm.trayItemsCount > 0 ? "Tray" : "Site"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$resourceString["basket.Sidebar.Checkout"]
                              ) +
                              "\n          "
                          ),
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--ko-arrow-next"
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isCheckoutPage
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "call-to-action-button btn btn-white border-dark w-100 justify-content-center",
                      attrs: {
                        onclick: "location.href='./basket'",
                        type: "button"
                      }
                    },
                    [
                      _c("span", {
                        staticClass:
                          "png-icon png-icon-icons-glyph--k-arrow-back position-static"
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$resourceString["checkout.BackToBasket"]) +
                          "\n        "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary call-to-action-button w-100 justify-content-center",
                      attrs: {
                        type: "button",
                        disabled: _vm.OrderSampleEnabled
                      },
                      on: { click: _vm.checkoutSubmitBtn }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$resourceString["checkout.Sidebar.Submit"]
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }